/**
* Directive for signup location
**/

(function(){

    /**
    * This directive handles all the interactivity between the Wizard and Google API
    **/
    SUGApp.directive('signupLocation', function(){
        return {
            restrict: 'EA',
            transclude: true,
            scope: {
                /*type 	: '@type'*/
                locationid : '@locationid',
                slotid : '@slotid',
                locationtype : '@locationtype',
                autoupdateslots : '@autoupdateslots',
                onLocationSelection : '&?',
                search : '@search'
            },
            templateUrl: "/view/templates/signuplocation/signuplocation-button.html",
            replace: true,
            controller: ['$scope', 'SUGUtilities', '$timeout', '$location', '$modal', '$compile', '$window',
            function( $scope, SUGUtilities, timeout, loc, $modal, $compile, $window ){
                
                /**
                 * Translate jQuery Modal into something AngularJS can read
                 * This enables the directive within the jQuery modal
                 * discovered by Todd Bruss and Robert Waddell
                 * this replaces the quickPop routine in dspDateOptions.cfm
                 **/
                 $scope.searchEnabled = ["true","1"].indexOf($scope.search.toString()) >= 0 ? true : false;
                 $window.quickPop = function(box,boxtitle){
                    $.get(box, function (rawcontent) {

                        var linkFn = $compile(rawcontent);
                        var content = linkFn($scope);
                        angular.element(document.querySelector('#quickBox')).html('');
                        angular.element(document.querySelector('#quickBox')).append(content);

                         $('#quickBox').dialog('option', 'title', boxtitle);
                         $('#quickBox').dialog('open').height('auto');
                    });
                };


                /**
                /*** Temp variables for Auto complete ***/

                $scope.streetaddress = '';
                $scope.addressDetails = '';

                /**
                * This takes an list of slotids and converts it into an array
                **/
                if ( $scope.slotid !== undefined ) {
                    $scope.slotid = $scope.slotid.split(',');
                }

                var locid = angular.element( '#' + $scope.locationtype + 'locationid' );

                //read in locationid from form if it is not available from the directive
                if ( $scope.locationid === undefined && Number( locid.val() ) > 0 ) {
                    $scope.locationid = angular.copy ( locid.val() );
                } else if ( $scope.locationid === undefined ){
                    $scope.locationid = '';
                }

                //To store more info as needed
                $scope.geoinfo = {};
                $scope.geoinfo.mid = window.userdef.memberid; // standard memberid
                $scope.geoinfo.locationid = $scope.locationid; //easy way ot import this data to the modal
                $scope.geoinfo.slotid = $scope.slotid; //easy way ot import this data to the modal
                $scope.geoinfo.init = true;
                $scope.geoinfo.gapi = typeof window.globalcfg.gapi !== 'undefined' ? window.globalcfg.gapi : "";
                $scope.geoinfo.autoupdateslots = $scope.autoupdateslots;

                $scope.gapi = function( ){
                    SUGUtilities.APISyncCall("post", "", 'gapi', "g.getGlobalVariable", 15000)
                    .then(function(response){
                        // Test for malformed response
                        if (ajaxResultInvalid(response)) {
                            // invalid response
                            $scope.geoinfo.gapi = '';
                            return false;
                        }
                        else {
                            var r = SUGUtilities.lowerCaseKeys( response );
                            $scope.geoinfo.gapi = r.data.data.variable;
                            var scrpt = document.createElement('script');
                            scrpt.src = 'api/js?libraries=geometry,places&key=' + $scope.geoinfo.gapi;
                            scrpt.async = true;
                            scrpt.type = 'text/javascript';
                            document.getElementsByTagName('head')[0].appendChild(scrpt);
                        }
                    });
                };

                // disabled for now - $scope.gapi()

                /** helpers **/
                var ajaxResultInvalid = function (result) {
                    result = SUGUtilities.lowerCaseKeys( result );
                    return (typeof result.data === 'undefined' || !result.data.success);
                };

                /* Show the modal */
                $scope.displaySignupLocationModal = function( geoinfo ){
                    var signuplocationWindow = $modal.open({
                        templateUrl: '/view/templates/signuplocation/signuplocation-modal.html',
                        controller: dspSignupLocationModal,
                        resolve : {
                            geoinfo: function(){
                                return geoinfo;
                            },
                            searchEnabled : function(){
                                return $scope.searchEnabled;
                            }
                        }
                    });

                    signuplocationWindow.result
                    .then( function(response){
                        if ( response.success ) {
                            try {
                                //clear if it is not filled out
                                if (response.data.locationid === 0) {
                                    response.data.locationid = '';
                                }

                                //get locationid
                                $scope.geoinfo.locationid = response.data.locationid;

                                //enter value in the element
                                //This will only get inserted, updates are handled with the directive
                                var locid = angular.element( '#' + $scope.locationtype + 'locationid' );
                                locid.val( $scope.geoinfo.locationid );

                                //bonus!
                                //set location name
                                $scope.locationname = response.data.name;
                                var locname = angular.element( '#' + $scope.locationtype + 'locationname' );

                                //fill out locationname
                                if (locname.val() == '') {
                                    locname.val ( $scope.locationname );
                                }

                                // if provided, execute the callback
                                if( angular.isDefined($scope.onLocationSelection) ){
                                    $scope.onLocationSelection({locationObj: response.data.selectedAddress});
                                }

                            } catch (e) {
                                $scope.locationid = '';
                            }

                            try {
                                $scope.slotid = response.data.slotid;
                            } catch (e) {
                                $scope.slotid = '';
                            }

                        } else {
                            // do nothing
                        }
                        //
                    });
                };

                /**
                * SignUp Location Helper Method
                * Displays the SignUp Location Modal
                **/
                $scope.signupLocationModal = function () {

                    var geoinfo = $scope.geoinfo;
                    //if this is moved, google variable complains. Weird!
                    $scope.displaySignupLocationModal( geoinfo );

                };


                /* Delete Modal View Controller */
                var dspSignupLocationModal = ['$scope','$modalInstance', 'geoinfo', '$timeout', 'SUGUtilities','$window','$filter','searchEnabled',
                function( $scope, $modalInstance, geoinfo, $timeout, SUGUtilities, $window, $filter, searchEnabled) {

                    /**
                    * This takes care of the subadmin scenario
                    * It now updates each time this is run.
                    **/
                    if ($window.userdef.parentid == $window.userdef.ownerid && Number($window.userdef.parentid !== 0) ) {
                        geoinfo.mid = $window.userdef.parentid; // check for parentid //could possibly use owner id...
                    } else {
                        geoinfo.mid = window.userdef.memberid; // standard memberid
                    }

                    //pull info if available
                    if ( geoinfo.locationid || geoinfo.slotid ) {
                        geoinfo.init = true;
                    }

                    geoinfo.shouldclose = false;
                    geoinfo.deleteid = 0;

                    $scope.searchEnabled = searchEnabled;
                    $scope.obj = {};
                    $scope.obj.details = {};
                    $scope.obj.streetaddress = "Test";
                    $scope.obj.userlocations = [];
                    $scope.obj.selectedAddress = {};
                    $scope.obj.defaultselection = "Select an Address";
                    $scope.obj.selection = angular.copy($scope.obj.defaultselection);
                    $scope.obj.parentSelected = false;
                    $scope.obj.parentSelection = {};
                    $scope.obj.errormessages = {
                        'name': 'Please enter a name',
                        'address1' : 'Please enter the street address',
                        'city' : 'Please enter your city',
                        'state' : 'Enter your state',
                        'zipcode' : 'Enter your zip',
                        'country' : 'Please enter your country'
                    };

                    $scope.obj.add = "Add New Address";
                    $scope.obj.edit = "Edit Address";
                    $scope.obj.addEditMessage = "Add New Address";
                    $scope.obj.showAddressForm = false;
                    $scope.obj.validation = false;
                    $scope.obj.editmode = false;

                    $scope.loc = {};
                    $scope.locSpinr = false;

                    //get the user's locations, (if we have any)
                    // get all geo location information based on IP
                    $scope.getLocationsByMember = function( ){
                        SUGUtilities.APISyncCall("post", "", {'memberid': geoinfo.mid}, "s.getLocationsByMember", 15000)
                        .then(function(response){
                            // Test for malformed response
                            if (ajaxResultInvalid(response)) {
                                $scope.obj.userlocations = [];
                                $scope.obj.showAddressForm = false;
                                return false;
                            }
                            else {
                                var r = SUGUtilities.lowerCaseKeys( response );
                                var d = r.data.data;

                                if ( d.length ) {
                                    $scope.obj.userlocations  = $filter('orderBy')(d,['name'],false);

                                    //get the selected location
                                    //check if we have a location already
                                    if ( geoinfo.init == true) {
                                        if ( geoinfo.locationid !== '' && geoinfo.locationid !== undefined ) {
                                            $scope.setLocation();

                                        //fall back on what is in the database
                                        } else if ( geoinfo.init && geoinfo.slotid && !geoinfo.locationid ) {
                                            $scope.getLocationBySlot(geoinfo);
                                        }
                                    }

                                } else {
                                    //clear the array and turn off the form
                                    $scope.obj.userlocations = [];
                                    $scope.obj.showAddressForm = false;
                                }
                            }
                        });
                    };

                    /**
                    /*  assign Location To Slot
                    **/
                    $scope.assignLocationToSlot = function(){

                        var slotids = [];
                        if (typeof geoinfo.slotid == 'string' ) {
                            //test for string, make it an array;
                            slotids = [ geoinfo.slotid ];
                        } else {
                            //must be an array;
                            slotids = geoinfo.slotid;
                        }

                        SUGUtilities.APISyncCall("post", "", {'memberid': geoinfo.mid, 'locationid': geoinfo.locationid, 'slotids': slotids}, "s.assignLocationToSlot", 15000)
                        .then(function(response){
                            // Test for malformed response
                            if (ajaxResultInvalid(response)) {
                                return false;
                            }
                            else {
                                var r = SUGUtilities.lowerCaseKeys( response );
                                var d = r.data.data;

                                // after everything close the window
                                if ( geoinfo.shouldclose ) {
                                    $scope.ok();
                                }

                            }
                        });
                    };

                    /**
                    * get Locations By Slot
                    **/
                    $scope.getLocationBySlot = function(geo){
                        SUGUtilities.APISyncCall("post", "", {'memberid': geo.mid, 'slotids': [geo.slotid]}, "s.getLocationBySlot", 15000)
                        .then(function(response){
                            // Test for malformed response
                            if (ajaxResultInvalid(response)) {
                                return false;
                            }
                            else {
                                var r = SUGUtilities.lowerCaseKeys( response );
                                var d = r.data.data;

                                for (var i in d) {

                                    if ( d[i].slotid == geo.slotid ) {
                                        geoinfo.locationid = d[i].locationid;
                                        $scope.setLocation();

                                    }
                                }
                            }
                        });
                    };

                    $scope.setLocation = function() {
                        //Clear the menu
                        for (var j in $scope.obj.userlocations) {


                            if ( geoinfo.deleteid > 0 && $scope.obj.userlocations[j].locationid === geoinfo.deleteid ) {
                                $scope.obj.selection = angular.copy($scope.obj.defaultselection);
                                $scope.obj.selectedAddress = {};

                                geoinfo.locationid = '';
                                geoinfo.init = false; //turn off init
                                geoinfo.deleteid = false;

                                break;
                            } else if ( geoinfo.locationid == $scope.obj.userlocations[j].locationid ) {
                                $scope.getSelection( $scope.obj.userlocations[j] );

                                geoinfo.init = false; //turn off init
                                break;
                            }
                        }
                    };

                    /**
                    * Create a signup location
                    **/
                    $scope.createSignupLocation = function( selectedAddress ){
                        SUGUtilities.APISyncCall("post", "", selectedAddress, "s.createSignupLocation", 15000)
                        .then(function(response){
                            // Test for malformed response
                            if (ajaxResultInvalid(response)) {
                                var msg = 'Invalid Response.';
                                var r = SUGUtilities.lowerCaseKeys( response );

                                if ( r.data.message[0] ) {
                                    msg = r.data.message[0];
                                } else {
                                    msg = 'An error has occurred during Save.';
                                }

                                SUGUtilities.showMagnificAlert(msg, '', '', 'Error');

                                return false;
                            }
                            else {
                                //SUGUtilities.showMagnificAlert('Your changes have been saved', '', '', 'Success!');
                                var r = SUGUtilities.lowerCaseKeys( response );
                                selectedAddress.locationid = r.data.data;

                                //update geoinfo locationid as well
                                geoinfo.locationid = selectedAddress.locationid;

                                // $scope.getLocationsByMember(); //update menu
                                $scope.buildMenuTitle(selectedAddress); // sets selected menu item

                                geoinfo.shouldclose = true;

                                /**
                                * This the current wizard, this is not used often as it
                                * handles most of the inserts and updates. where we moved most of its functionality
                                * There may be more use for this in the new wizard
                                **/
                                if ( geoinfo.slotid && geoinfo.autoupdateslots == '1' ) {
                                    $scope.assignLocationToSlot(); //assign the location to slot(s), can be an array or single string
                                } else {
                                    $scope.ok();
                                }
                            }
                        });
                    };


                    /**
                    * Save an Address
                    **/
                    $scope.saveAddress = function( selectedAddress, assignOnly ) {

                        try {
                            //fix for iPad
                            if ( $scope.obj.parentSelected === true ) {
                                $scope.setAddress($scope.obj.parentSelection);
                            }
                        } catch (e) {
                            //Do nothing
                        }

                        var shouldValidate = false;
                        // if any of the elements are filled in, we validate it
                        if( typeof selectedAddress === 'object' ){
                            for (var key in selectedAddress) {
                                // skip prototype keys
                                if (!selectedAddress.hasOwnProperty(key))
                                    continue;
                                var obj = selectedAddress[key];
                                if( obj !== 'undefined' && obj !== '' )
                                    shouldValidate = true;
                            }
                        }

                        if ( !shouldValidate ) {
                            /**
                            * Initialize values before save
                            **/
                            shouldValidate = false;
                            $scope.clearform(true);
                            selectedAddress = $scope.obj.selectedAddress;
                            geoinfo.locationid = 0;
                            selectedAddress.locationid = 0;
                            geoinfo.shouldclose = true;

                            //assign the location to slot(s)
                            //can be array or single string
                            //slots are usually updated in the Wizard
                            //this directive has additonal functionalilty for updating the locations for slots
                            if ( geoinfo.slotid && geoinfo.autoupdateslots == '1' ) {
                                $scope.assignLocationToSlot();
                            } else {
                                $scope.ok();
                            }

                            //commented out.. have a value of undefined error
                            //$modalInstance.close({success:true,data:geoinfo,message:'success'});
                        }

                        var err = false;

                        /**
                        ** Validate the form before we try to save
                        **/
                        if ( shouldValidate ) {
                            $scope.obj.validation = true;
                            for (var key in $scope.obj.errormessages) {
                                if ($scope.obj.errormessages.hasOwnProperty(key)) {

                                    err = $scope.errorExists( key );

                                     if (err) {
                                         break; // Displays the error(s)
                                     }
                                }
                            }
                        }

                        /**
                        ** We passed the check point, save the address
                        **/
                        if (!err && $scope.obj.validation) {
                            $scope.obj.validation = false;

                            var sa = angular.copy(selectedAddress);

                            if ( sa.coordinate === '' || sa.coordinate == undefined ) {
                                 //selectedAddress.coordinate = 'null,null'
                                 sa.coordinate = '';
                            } else {

                                //here we will grab the address that we want to verify
                                var address = '';

                                if ( sa.address1  !== '' ) {
                                    address = address + sa.address1 + ', ';
                                }

                                if ( sa.address2 !== '' ) {
                                    address = address + sa.address2 + ', ';
                                }

                                if ( sa.city  !== '' ) {
                                    address = address + sa.city + ', ';
                                }

                                if ( sa.zipcode  !== '' ) {
                                    address = address + sa.zipcode + ', ';
                                }

                                if ( sa.country  !== '' ) {
                                    address = address + sa.country;
                                }

                                  var geocoder = new google.maps.Geocoder();
                                  var newcoordinate = '';

                                  /**
                                  * Verify that the coordinates are correct;
                                  **/
                                  geocoder.geocode( { 'address': address}, function(results, status) {
                                    if (status == 'OK') {
                                        var lat = results[0].geometry.location.lat();
                                        var lng = results[0].geometry.location.lng();
                                        newcoordinate = lat + ',' + lng;

                                        if ( newcoordinate !== sa.coordinate && newcoordinate !== '' ) {

                                            var split1 = newcoordinate.split(',');
                                            var split2 = sa.coordinate.split(',');
                                            var accuracy = 100; //100 = 0.01 two decimal places
                                            split1[0] = Math.round( split1[0] * accuracy ) / accuracy;
                                            split2[0] = Math.round( split2[0] * accuracy ) / accuracy;
                                            split1[1] = Math.round( split1[1] * accuracy ) / accuracy;
                                            split2[1] = Math.round( split2[1] * accuracy ) / accuracy;

                                            // If the numbers are off by more than our accuracy then get new coordinates
                                            if (split1[0] !== split2[0] || split1[1] !== split2[1] ) {
                                                selectedAddress.coordinate = newcoordinate;
                                            }
                                        }
                                    } else {
                                        console.warn('Geocode was not successful for the following reason: ' + status);
                                    }
                                  });
                            }

                            selectedAddress.memberid = geoinfo.mid;

                            // if coorindates are missing
                            // set it to an empty string
                            if ( selectedAddress.coordinate == undefined ) {
                                selectedAddress.coordinate = ''; //this is required
                            }

                            // if we're saving the data
                            if( typeof assignOnly === 'undefined' ){
                                $scope.createSignupLocation( selectedAddress );
                            }
                            else {
                                geoinfo.locationid = selectedAddress.locationid;
                                $scope.buildMenuTitle(selectedAddress); // sets selected menu item
                                geoinfo.shouldclose = true;
                                if ( geoinfo.slotid && geoinfo.autoupdateslots == '1' ) {
                                    $scope.assignLocationToSlot();
                                } else {
                                    $scope.ok();
                                }
                            }
                        }
                    };

                    /**
                    /* Remove a signup location
                    **/
                    $scope.deleteSignupLocation = function( deleteAddress ){
                        SUGUtilities.APISyncCall("post", "", deleteAddress , "s.deleteSignupLocation", 15000)
                        .then(function(response){
                            // Test for malformed response
                            if (ajaxResultInvalid(response)) {
                                return false;
                            }
                            else {

                                geoinfo.deleteid = deleteAddress.locationid;

                                var r = SUGUtilities.lowerCaseKeys( response );
                                $scope.setLocation();
                                $scope.getLocationsByMember(); //update menu
                            }
                        });
                    };

                    /**
                    /* Ask the user before we delete an address
                    **/
                    $scope.deleteAddressConfirmation = function(del){
                        var msg = '<div class="spacer-sm"></div>Are you sure you want to delete this address? The address link will be removed from any sign ups using the address.<div class="spacer-sm"></div>';
                        SUGUtilities.showConfirmationModal({
                            txtConfirmationTitle: 'Are you sure?',
                            txtConfirmationMessage: msg + del.name + '<br>' + del.address1 + ' ' + del.address2 + '<br>' + del.city + ', ' + del.state + ', ' + del.zipcode,
                            lblYesButton: 'Yes, Delete',
                            lblCancelButton: 'Cancel'
                        }, function(x){

                            del.memberid = geoinfo.mid;
                            $scope.deleteSignupLocation( del );

                            if ( del.locationid == $scope.obj.selectedAddress.locationid ) {
                                var cleargapiaddress = true;
                                $scope.clearform(cleargapiaddress);
                            }
                        });
                    };

                    /**
                    ** Clear the address form
                    **/
                    $scope.clearform = function(clearGapiAddress) {
                        var clear = ['coordinate','locationid','memberid','lat','lng','coordinate','name','address1','address2','city','state','zipcode','country'];

                        //clear the address form
                        for (var i in clear) {
                            var c = clear[i];
                            $scope.obj.selectedAddress[ c ] = ''; //Fill the form out

                            //remove locationid if its new
                            if ( c ==  'locationid' ) {
                                delete $scope.obj.selectedAddress['locationid'];
                            }
                        }

                        if (clearGapiAddress && typeof $scope.obj.selectedAddress === 'object' ) {
                            $scope.obj.selectedAddress[ 'gapiaddress' ] = ''; //Fill the form out
                        }
                    };

                    //get the member's locations
                    $scope.getLocationsByMember();

                    //builds the current menu title
                    $scope.buildMenuTitle = function (selectedAddress) {
                        $scope.obj.selection = '';

                        if (angular.equals( selectedAddress, 'No Address' ) ) {
                            $scope.obj.selection = "Select an Address";
                            var cleargapiaddress = true;
                            $scope.clearform(cleargapiaddress);
                            $scope.obj.showAddressForm = false;
                        } else {
                            if ( $scope.obj.selectedAddress.name  !== '' ) {
                                $scope.obj.selection = $scope.obj.selection + $scope.obj.selectedAddress.name + ', ';
                            }

                            if ( $scope.obj.selectedAddress.address1  !== '' ) {
                                $scope.obj.selection = $scope.obj.selection + $scope.obj.selectedAddress.address1 + ', ';
                            }

                            if ( $scope.obj.selectedAddress.address2  !== '' ) {
                                $scope.obj.selection = $scope.obj.selection + $scope.obj.selectedAddress.address2 + ', ';
                            }

                            if ( $scope.obj.selectedAddress.city  !== '' ) {
                                $scope.obj.selection = $scope.obj.selection + $scope.obj.selectedAddress.city + ', ';
                            }

                            if ( $scope.obj.selectedAddress.zipcode  !== '' ) {
                                $scope.obj.selection = $scope.obj.selection + $scope.obj.selectedAddress.zipcode + ', ';
                            }

                            if ( $scope.obj.selectedAddress.country  !== '' ) {
                                $scope.obj.selection = $scope.obj.selection + $scope.obj.selectedAddress.country;
                            }
                        }
                    };

                    //set's the selection (edit)
                    $scope.setSelection = function(selectedAddress) {
                        var cleargapiaddress = true;
                        $scope.clearform(cleargapiaddress);
                        $scope.obj.showAddressForm = true;
                        $scope.obj.selectedAddress = angular.copy(selectedAddress);
                        $scope.buildMenuTitle(selectedAddress);

                    };

                    /**
                    /* Ask the user before we delete an address
                    **/
                    $scope.editAddress = false;
                    $scope.editAddressConfirmation = function(selectedAddress){
                        var msg = '<div class="spacer-sm"></div>Are you sure you want to edit this address? All sign ups using this address link will also be updated.<div class="spacer-sm"></div>';
                        SUGUtilities.showConfirmationModal({
                            txtConfirmationTitle: 'Are you sure?',
                            txtConfirmationMessage: msg + selectedAddress.name + '<br>' + selectedAddress.address1 + ' ' + selectedAddress.address2 + '<br>' + selectedAddress.city + ', ' + selectedAddress.state + ', ' + selectedAddress.zipcode,
                            lblYesButton: 'Yes, Continue',
                            lblCancelButton: 'Cancel'
                        }, function(x){
                            $scope.editAddress = true;
                            $scope.setSelection(selectedAddress);
                        }, function(){
                            $scope.editAddress = false;
                        });
                    };

                    //grabs the parent select incase this is on iPad
                    $scope.grabObject = function(selectedAddress) {
                        $scope.obj.parentSelected = true;
                        $scope.obj.parentSelection = selectedAddress;
                    };

                    //get's the selection (grab)
                    $scope.getSelection = function(selectedAddress) {

                        $scope.obj.parentSelected = false;

                        var cleargapiaddress = true;
                        $scope.clearform(cleargapiaddress);
                        $scope.obj.showAddressForm = false;
                        $scope.obj.selectedAddress = angular.equals( selectedAddress, 'No Address' ) ? {} : angular.copy(selectedAddress);
                        $scope.buildMenuTitle(selectedAddress);
                    };

                    //delete address confirmation helper method
                    $scope.deleteAdd = function(del) {
                        //get address confirmation first
                        //then proceed
                        $scope.deleteAddressConfirmation(del);
                    };

                    //invalid
                    var ajaxResultInvalid = function (result) {
                        result = SUGUtilities.lowerCaseKeys( result );
                        return (typeof result.data === 'undefined' || !result.data.success);
                    };

                    /**
                    ** Error exists on form, show the error(s)
                    **/
                    $scope.errorExists = function( key ) {

                        if ( $scope.obj.validation ) {
                            var err =  $scope.obj.selectedAddress[key] ? $scope.obj.selectedAddress[key] : '';
                            return !err;
                        } else {
                            return false;
                        }

                    };

                    //add-address
                    $scope.addNewAddress = function() {
                        $scope.editAddress = false;
                        $scope.obj.parentSelected = false;

                        var cleargapiaddress = true;
                        $scope.clearform(cleargapiaddress);

                        $scope.obj.showAddressForm = true //!$scope.obj.showAddressForm;
                        $scope.obj.selection = angular.copy($scope.obj.defaultselection);
                        $scope.obj.selectedAddress = {};
                    };

                    /**
                    ** Here are are translating the google address info, to our address
                    **/
                    $scope.setAddressFields = function(details) {

                        var cleargapiaddress = false;
                        $scope.clearform(cleargapiaddress);

                        $scope.obj.showAddressForm = true;

                        $scope.obj.selectedAddress.lat = details.geometry.location.lat();
                        $scope.obj.selectedAddress.lng = details.geometry.location.lng();
                        $scope.obj.selectedAddress.coordinate = $scope.obj.selectedAddress.lat + ',' + $scope.obj.selectedAddress.lng;

                        //Google Keys
                        var street_number = 'street_number';
                        var streetKeys = ['route','place','address2']; //how google calls these
                        var streetKeysB = ['address1','name','address2'];//how we call these
                        var locationKeys = ['subpremise','locality','administrative_area_level_1','postal_code','country'];//google
                        var locationKeysB = ['address2','city','state','zipcode','country'];//us

                        var address1 = '';
                        var addrObj = details.address_components;
                        var place = details.name !== undefined ? details.name : "";
                        var streetaddress = '';
                        var loc = '';
                        $scope.obj.selectedAddress.name = place;

                        // The first two parts build the street address
                        for (var x in addrObj) {

                            //look at first key, but use short names
                            loc = addrObj[x].types[0];

                            //street number
                            if ( loc == street_number ) {
                                address1 = addrObj[x].short_name;
                                //street name
                            } else if ( loc == streetKeys[0] ) {

                                streetaddress = address1 + ' ' + addrObj[x].short_name;
                                $scope.obj.selectedAddress[ streetKeysB[0] ] = streetaddress; //save the street address and compare with name;

                                //We can save this to use as a checksum later to validate the coordinates based on this address
                                //If the user edits address1, we should pull new coordinates (set up later via geocode)
                                //This part described is not done yet, we are using address as the primary location source
                                //So a backup check on the coordinates has not been implemented yey andit will requires another Google API check

                                $scope.obj.geocodeaddress = angular.copy(streetaddress);
                                //fill out the name of the place
                                if ( streetaddress !== place ) {
                                    $scope.obj.selectedAddress[ streetKeysB[1] ] = place; //save the street address and compare with name;
                                }
                            }
                        }

                        //fill out the rest
                        for (var x in addrObj) {
                            loc = addrObj[x].types[0];
                            for (var i in locationKeys) {
                                var key = locationKeys[i]; //google
                                var keyB = locationKeysB[i]; //us
                                var value = '';
                                if ( loc == key ) {

                                    if ( key !== 'country') {
                                        value = addrObj[x].short_name;
                                    } else {
                                        value = addrObj[x].long_name;
                                    }

                                    $scope.obj.selectedAddress[ keyB ] = value; //Fill the form out
                                }
                            }
                        }

                        $scope.buildMenuItem();
                    };

                    /**
                    ** This checks if the user selected an new address using the Google API
                    **/
                    $scope.$watch(
                        function () {
                            return $window.locationDetails;
                        }, function(locationDetails,o){
                            //gapi address lookup changed
                            if ( locationDetails !== undefined && locationDetails !== null ) {
                                try  {
                                    if (locationDetails.address_components !== undefined ) {
                                        $scope.obj.parentSelected = false;
                                        $scope.setAddressFields(locationDetails);
                                    }
                                } catch (e) {
                                    //do nothing because we have nothing to work with here!
                                }
                            }
                        }
                    );

                    //Do not show the spinner
                    //We may use this elsewhere
                    $scope.locSpinr = false;

                    /**
                    * method loadSpinner, dependent on spin.js
                    * the parameters can be turned into variables, too.
                    **/
                    function showLoading( displayElem, left, top ){

                        var topPosition = '19px';
                        var leftPosition = '14px';
                        if( typeof top !== 'undefined' )
                        topPosition = top;
                        if( typeof left !== 'undefined' )
                        leftPosition = left;
                        var opts = {
                            lines: 15, length: 8, width: 2, radius: 8, corners: 1, left: leftPosition, top: topPosition,
                            rotate: 0, direction: 1, speed: 1, color: '#ef9934', trail: 60,
                            shadow: false, hwaccel: false, className: 'spinner', zIndex: 2e9
                        };

                        var target = document.getElementById(displayElem);
                        var spinner = new Spinner(opts).spin( target );
                    }

                    /**
                    * show spinner
                    **/

                    /* Handler for Processing Status */
                    $timeout ( function () {
                        showLoading('locationSpinner');
                    }, 1);

                    /* stop the spinner */
                    $scope.stopSpinner = function() {
                        $timeout ( function () {
                            $scope.locSpinr = false;
                        }, 1);
                    };

                    /**
                    * The user pressed Save.
                    **/
                    $scope.ok = function () {
                        geoinfo.name = $scope.obj.selectedAddress.name;
                        geoinfo.selectedAddress = angular.copy($scope.obj.selectedAddress);
                        $scope.clearform(true);
                        $scope.obj.showAddressForm = false;
                        $window.locationDetails = null;
                        $modalInstance.close({success:true,data:geoinfo,message:'success'});
                    };

                    /**
                    * The user cancelled.
                    **/
                    $scope.cancel = function () {
                        $scope.clearform(true);
                        $scope.obj.showAddressForm = false;
                        $window.locationDetails = null;
                        $modalInstance.dismiss({success:false,data:'',message:'cancel'});
                    };
                }];

            }]
        };
    });

    /* Begin Autocomplete Directive */

    /**
    * This directive talks to the Google API and pulls the address data
    * It is used on the signup-location-modal
    **/
    SUGApp.directive('ngAutocomplete', function() {
        return {
            require: 'ngModel',
            scope: {
                ngModel: '=',
                details: '=',
                charlen: '@',
                blur:    '=',
                focus:   '='
            },
            link: function(scope, element, attrs, controller) {
                var autoCompleteListener;
                var sessionToken = new google.maps.places.AutocompleteSessionToken();
                scope.charLen = typeof scope.charLen === 'undefined' || scope.charlen === '' ? 4 : parseInt(scope.charLen);
                scope.$watch("ngModel", function(nval,oval){
                    if( typeof nval !== 'undefined' && nval.length >= scope.charlen ){

                        var allowedFunctions = {
                            blurGoogleAutoComplete: function() {
                                document.getElementById("GoogleAutocomplete").blur();
                            },
                            focusGoogleAutoComplete: function(name) {
                                document.getElementById("GoogleAutocomplete").focus(); 
                            }
                        };
                        
                        var executeTimeOutFunction = function( funcName, delay ){
                            if (allowedFunctions.hasOwnProperty(funcName)) {
                                setTimeout(() => {
                                    allowedFunctions[funcName]();
                                }, delay);
                            } 
                        };

                        executeTimeOutFunction('blurGoogleAutoComplete', scope.blur);
                        if (typeof scope.gPlace === 'undefined') {
                            fireListener();
                        }
                        executeTimeOutFunction('focusGoogleAutoComplete', scope.focus);
                    }
                    
                    else if ( typeof scope.gPlace !== 'undefined' ){
                        //remove listener
                        google.maps.event.removeListener(autoCompleteListener);

                        //remove listener on the only elment are using
                        google.maps.event.clearInstanceListeners(element[0]);

                        //clear the gPlace variable, keeps just one instance of places in memory
                        scope.gPlace = undefined;
                        autoCompleteListener = undefined;

                        //remove the pac-container, otherwise multiple containers will be on top of each other;
                        angular.element(document.querySelector(".pac-container")).remove();
                    }
                });

                //options for autocomplete
                var watchEnter = false;

                // start listener
                var fireListener = function(){
                    scope.gPlace = new google.maps.places.Autocomplete(element[0], {sessiontoken:sessionToken});
                    autoCompleteListener = google.maps.event.addListener(scope.gPlace, 'place_changed', function() {
                        var result = scope.gPlace.getPlace();
                        if (result !== undefined) {
                            if (result.address_components !== undefined) {
                                scope.$apply(function() {
                                    scope.details = result;
                                    controller.$setViewValue(element.val());
                                    window.locationDetails = result;
                                });
                            }
                            else {
                                if (watchEnter) {
                                    getPlace(result);
                                }
                            }
                        }
                    });
                };

                //function to get retrieve the autocompletes first result using the AutocompleteService
                var getPlace = function(result) {
                    var autocompleteService = new google.maps.places.AutocompleteService();
                    if (result.name.length > 0){
                        autocompleteService.getPlacePredictions(
                            {
                                input: result.name,
                                offset: result.name.length
                            },
                            function listentoresult(list, status) {
                                if(list == null || list.length == 0) {
                                    scope.$apply(function() {
                                        scope.details = null;
                                        window.locationDetails = null;
                                    });
                                } else {
                                    var placesService = new google.maps.places.PlacesService(element[0]);
                                    placesService.getDetails(
                                        {'reference': list[0].reference},
                                        function detailsresult(detailsResult, placesServiceStatus) {
                                            if (placesServiceStatus == google.maps.GeocoderStatus.OK) {
                                                scope.$apply(function() {
                                                    controller.$setViewValue(detailsResult.formatted_address);
                                                    element.val(detailsResult.formatted_address);
                                                    scope.details = detailsResult;
                                                    window.locationDetails = detailsResult;
                                                    //on focusout the value reverts, need to set it again.
                                                    var watchFocusOut = element.on('focusout', function(event) {
                                                        scope.details = detailsResult;
                                                        window.locationDetails = detailsResult;
                                                        element.val(detailsResult.formatted_address);
                                                        element.unbind('focusout')
                                                    });
                                                });
                                            }
                                        }
                                    );
                                }
                            });
                        }
                    };
                    controller.$render = function () {
                        var location = controller.$viewValue;
                        element.val(location);
                    };
                }
            };
        });

    }());
